import { Instance, types } from 'mobx-state-tree';
import { ConfirmModal } from './models/ConfirmModal';
import NotificationToast from '../components/common/NotificationToast';

export const ModalStore = types
  .model('ModalStore', {
    confirm: types.optional(ConfirmModal, {
      isOpen: false,
      title: '',
      content: '',
      cancelDisabled: false,
    }),
  })
  .actions((self) => {
    const showToast = (title: string, message: string) => {
      NotificationToast.openNotification(title, message);
    };

    return {
      showToast,
    };
  });

export type ModalStoreType = Instance<typeof ModalStore>;
